import dd from './icon_dd.png'
import dd_active from './icon_dd_active.png'
import fl from './icon_fl.png'
import fl_active from './icon_fl_active.png'
import sy from './icon_sy.png'
import sy_active from './icon_sy_active.png'
import wd from './icon_wd.png'
import wd_active from './icon_wd_active.png'
export default {
    dd: {
        nor: dd,
        act: dd_active
    },
    fl: {
        nor: fl,
        act: fl_active
    },
    sy: {
        nor: sy,
        act: sy_active
    },
    wd: {
        nor: wd,
        act: wd_active
    },
}



// WEBPACK FOOTER //
// ./src/assets/img/tab/index.js